import React, { useEffect, useState } from 'react';
import { Table, Card, Space, Form, Select, Input, Pagination, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import EditUser from './EditUser';
import { isEmpty } from "lodash";
import AddUser from './AddUser';
import UploadExcel from './UploadExcel';
import moment from 'moment-jalaali';
import UserSales from './UserSales';
import strings from '../../utils/strings';
import UserBought from './UserBougth'
import UserWageSetting from './UserWageSetting';
import UserEndorsementReport from './UserEndorsementReport';
import ChangeMobileModal from './ChangeMobileModal';
import UserServices from '../../services/UserServices';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { useReportsStore } from '../../store/slices/createReportsSlice';



export default function Users() {
    const reports = useReportsStore();
    const general = useGeneralStore();
    const { auth, business, users, getBusinessRole, FILTERED_ITEM, FILTER_USERS, GET_ALL_USERS, GET_SINGLE_USER, GET_USER_AGENT_WAGE, GET_USER_SALE, SALE_LOADING, USER_LOADING, SET_TOTAL_USERS } = usePersistedStore()
    const navigate = useNavigate();
    let { pageNumber } = useParams();
    const [form] = Form.useForm();

    const [search, setSearch] = useState(false);
    const [member, set_member] = useState("")
    const [sortDirection, set_sortDirection] = useState("")
    const [filteredInfo, setFilteredInfo] = useState([]);
    const [selectedUserName, setSelectedUserName] = useState(null);
    const [filterLoading, setFilterLoading] = useState(false);
    const [activeFilters, setActiveFilters] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedMobileUserName, setSelectedMobileUserName] = useState(null);
    const [selectedMobileUser, setSelectedMobileUser] = useState(null);
    const [isFromFilter, setIsFromFilter] = useState(false);
    const [selectedEndorsementUserId, setSelectedEndorsementUserId] = useState(null);
    const [boughtUserId, setBoughtUserId] = useState(null);
    const pageSize = 10
    const initLoading = users.loading;
    const usersList = users.filtered;
    const TotalUsers = users.totalUsers;
    const usersData = users.data;


    const currentBusiness = business.currentBusiness;
    const marketerSystem = currentBusiness?.data?.marketerSystem;
    const provinces = general.provinces.data.Provinces;
    const roleList = business.businesses.roles.Roles;
    const userInfoResources = auth.userInfo.Resources;
    const { token } = currentBusiness;

    function setAFee(recordId) {
        general.ToggleUserWageSettingModal();

        UserServices.getUserAgentWage(recordId, token).then((res) => {
            GET_USER_AGENT_WAGE(res.data)
        }).catch((error) => {
            console.error("🚀 ~ UserServices.getUserAgentWage ~ error:", error)
        })

        setSelectedUserId(recordId);
    }

    useEffect(() => {
        if (isEmpty(provinces)) general.getProvinces();
        if (!token) navigate('/dashboard');
        getusers()
    }, [navigate, token, pageNumber]);

    useEffect(() => {
        if (sortDirection !== '' || member !== '') getusers();
    }, [sortDirection, member]);

    async function editOneUser(user) {
        await UserServices.getOneUser(user, token).then((res) => {
            GET_SINGLE_USER(res.data)
            general.ToggleEditUserModal();
        }).catch((error) => {

        })
    }

    useEffect(() => {
        if (!roleList?.length) {
            getBusinessRole()
        }
    }, [roleList, getBusinessRole])


    function getUserSale(Username) {
        SALE_LOADING(true)
        general.ToggleUserSalesModal();
        UserServices.getUserSale(Username, token).then((res) => {
            GET_USER_SALE(res.data.Sales)
            SALE_LOADING(false)
        }).catch((error) => {
            SALE_LOADING(false)
        })
        setSelectedUserName(Username)
    }
    // preventing of api duplication call in paginantion after filtering
    useEffect(() => {
        setTimeout(() => {
            if (isFromFilter)
                setIsFromFilter(false)
        }, 5000);
    }, [isFromFilter])

    function getusers() {

        if (isFromFilter) return;
        USER_LOADING(true)
        if (token)
            UserServices.getUsersPerPage(token, {
                sorts: [{
                    Member: member,
                    SortDirection: sortDirection
                }],
                page: pageNumber,
                pageSize: pageSize,
                filters: activeFilters.length > 0 ? activeFilters : null,
                groups: null,
                aggregates: null

            }).then((res) => {
                GET_ALL_USERS(res.data.Data)
                SET_TOTAL_USERS(res.data.Total)
                USER_LOADING(false)
            }).catch((error) => {
                USER_LOADING(false)

            })
    }

    const handleFilters = (filterValues) => {
        const filters = [];

        const filterableFields = [
            'UserName',
            'FirstName',
            'LastName',
            'DisplayName',
            'ProvinceId',
            'RoleIds',
            "Enabled",
        ];

        const filterKeyValueFinder = (field, filterValues) => {
            if (field === 'RoleIds') {
                return {
                    Member: 'RoleNames',
                    Operator: 2,
                    value: filterValues[field].toString(),
                };
            } else if (field === 'ProvinceId') {
                return {
                    Member: 'ProvinceTitle',
                    Operator: 2,
                    value: filterValues[field],
                };
            } else if (field === 'Enabled') {
                return {
                    Member: 'Enabled',
                    Operator: 2,
                    value: filterValues[field],
                };
            } else {
                return {
                    Member: field,
                    Operator: 8,
                    value: filterValues[field],
                };
            }
        };

        filterableFields.forEach((field) => {
            if (filterValues[field]) {
                filters.push(filterKeyValueFinder(field, filterValues));
            }
        });

        setActiveFilters(filters);
        setFilterLoading(true)
        UserServices.getUsersPerPage(token, {
            sorts: [{
                Member: member,
                SortDirection: sortDirection
            }],
            page: "1",
            pageSize: pageSize,
            filters: filters.length > 0 ? filters : null,
            groups: null,
            aggregates: null
        }).then((res) => {
            setFilterLoading(false)
            GET_ALL_USERS(res.data.Data);
            SET_TOTAL_USERS(res.data.Total);
            USER_LOADING(false);
            setIsFromFilter(true)
            setTimeout(() => {
                pageChange(1);
            }, 1000);
        }).catch((err) => {
            setFilterLoading(false)
        });
    }

    const handleChange = (pagination, filters, sorter, extra) => {
        setFilteredInfo(filters.RoleIds);
    };

    const pageChange = (e) => {
        navigate(`/dashboard/users/${e}`)
    }

    const SearchForm = () => {
        return (
            <Card>
                <Form
                    form={form} onFinish={handleFilters} layout="vertical">
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item name="UserName" label="نام کاربری">
                                <Input placeholder="نام کاربری را وارد کنید" />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="DisplayName" label="نام نمایشی">
                                <Input placeholder="نام نمایشی را وارد کنید" />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="FirstName" label="نام">
                                <Input placeholder="نام را وارد کنید" />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="LastName" label="نام خانوادگی">
                                <Input placeholder="نام خانوادگی را وارد کنید" />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="ProvinceId" label="استان">
                                <Select placeholder="استان را انتخاب کنید">
                                    {provinces?.map(province => (
                                        <Select.Option key={province.Id} value={province.Id}>
                                            {province.Title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item name="RoleIds" label="نقش‌ها">
                                <Select mode="multiple" placeholder="نقش‌ها را انتخاب کنید">
                                    {roleList?.map(role => (
                                        <Select.Option key={role.Id} value={role.Id}>
                                            {role.Title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">

                            <Form.Item name="Enabled" label="وضعیت">
                                <Select placeholder="انتخاب وضعیت">
                                    <Select.Option value="">همه</Select.Option>
                                    <Select.Option value={true}>فعال</Select.Option>
                                    <Select.Option value={false}>غیرفعال</Select.Option>
                                </Select>
                            </Form.Item>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '.5rem',
                                justifyContent: 'end'
                            }}
                            className="col-md-3">
                            <Button
                                style={{
                                    height: 40
                                }} onClick={() => form.resetFields()} className="mr-2">
                                پاک کردن
                            </Button>
                            <Button
                                loading={filterLoading || initLoading}
                                style={{
                                    height: 40
                                }}
                                type="primary" htmlType="submit">
                                اعمال فیلتر
                            </Button>
                        </div>
                    </div>
                </Form>
            </Card>
        );
    };

    const columns = [
        {
            title: "نام نمایشی",
            dataIndex: "DisplayName",
            key: "DisplayName",
            ellipsis: true,
            width: 150,
            sorter: (a, b, sortOrder) => {
                if (sortOrder === "ascend") {
                    set_sortDirection("Ascending");
                    set_member("DisplayName");
                } else if (sortOrder === "descend") {
                    set_sortDirection("Descending");
                    set_member("DisplayName");
                }
            },
            render: (text) => <span style={{ color: "#5ec393" }}>{text}</span>,
        },
        {
            title: "نام کاربری",
            dataIndex: "Username",
            key: "Username",
            width: 150,
            sorter: (a, b, sortOrder) => {
                if (sortOrder === "ascend") {
                    set_sortDirection("Ascending");
                    set_member("Username");
                } else if (sortOrder === "descend") {
                    set_sortDirection("Descending");
                    set_member("Username");
                }
            }
        },
        {
            title: "سطح دسترسی",
            dataIndex: "RoleNames",
            key: "RoleNames",
            width: 180,
            filterMultiple: true,
            sorter: (a, b, sortOrder) => {
                if (sortOrder === "ascend") {
                    set_sortDirection("Ascending");
                    set_member("RoleNames");
                } else if (sortOrder === "descend") {
                    set_sortDirection("Descending");
                    set_member("RoleNames");
                }
            },
            render: (roles) => <div>{roles}</div>
        },
        {
            title: "وضعیت",
            dataIndex: "Enabled",
            key: "Enabled",
            width: 120,

            sorter: (a, b, sortOrder) => {
                if (sortOrder === "ascend") {
                    set_sortDirection("Ascending");
                    set_member("Enabled");
                } else if (sortOrder === "descend") {
                    set_sortDirection("Descending");
                    set_member("Enabled");
                }

            },
            render: (data) => (data ? <span>فعال</span> : <span>غیرفعال</span>),
        },
        {
            title: "استان",
            dataIndex: "ProvinceTitle",
            key: "ProvinceTitle",
            width: 120,
            sorter: (a, b, sortOrder) => {
                if (sortOrder === "ascend") {
                    set_sortDirection("Ascending");
                    set_member("ProvinceTitle");
                } else if (sortOrder === "descend") {
                    set_sortDirection("Descending");
                    set_member("ProvinceTitle");
                }
            },
            render: (province) =>
                province &&
                provinces &&
                provinces.filter((item) => item.Id === province)[0]?.Title,
        },
        {
            title: "آخرین بازدید",
            dataIndex: "LastUsed",
            key: "LastUsed",
            width: 120,
            sorter: (a, b, sortOrder) => {
                if (sortOrder === "ascend") {
                    set_sortDirection("Ascending");
                    set_member("LastUsed");
                } else if (sortOrder === "descend") {
                    set_sortDirection("Descending");
                    set_member("LastUsed");
                }
            },
            render: (data) =>
                data && strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm ")),
        },

        {
            title: "تاریخ ثبت‌نام",
            dataIndex: "CreationTime",
            key: "CreationTime",
            width: 120,
            sorter: (a, b, sortOrder) => {
                if (sortOrder === "ascend") {
                    set_sortDirection("Ascending");
                    set_member("CreationTime");
                } else if (sortOrder === "descend") {
                    set_sortDirection("Descending");
                    set_member("CreationTime");
                }
            },
            render: (data) =>
                data && strings.getFarsiNum(moment(data).format(" jYYYY/jMM/jDD  ساعت:  HH:mm ")),
        },

        {
            title: "",
            dataIndex: "operation",
            key: "operation",
            ellipsis: true,
            width: 530,
            render: (_, record) => {

                const isNormalCustomer = !record.IsMarketer && (!record.RoleNames || (!String(record.RoleNames).includes("بازاریاب") && !String(record.RoleNames).toLowerCase().includes("marketer")));
                const hasBimehContent = Boolean(
                    currentBusiness?.data?.showBimeContent ||
                    currentBusiness?.data?.showBimehContent ||
                    currentBusiness?.showBimeContent ||
                    currentBusiness?.showBimehContent ||
                    business?.businesses?.byToken?.showBimeContent ||
                    business?.businesses?.byToken?.showBimehContent
                );
                const hasMobileChangePermission = Boolean(userInfoResources?.includes("CustomerMobileNumberChange"));

                return usersList.length >= 1 && (
                    <Space size="middle">
                        <button type="dashed" className="btn btn-warning btn-sm waves-effect waves-light"
                            onClick={() => {
                                editOneUser(record.Username)
                                if (!roleList?.length) {
                                    getBusinessRole()
                                }
                            }}>
                            <i className="far fa-edit font-size-16 align-middle mr-2"></i> ویرایش
                        </button>
                        <button type="dashed" className="btn btn-primary btn-sm waves-effect waves-light"
                            onClick={() => {
                                setBoughtUserId(record.Id);
                                general.ToggleUserBoughtModal();
                            }}>
                            <i className="fas fa-file-alt font-size-16 align-middle mr-2"></i> خریدها
                        </button>
                        {userInfoResources && userInfoResources?.includes("BusinessAdmin") && (
                            <button type="dashed" className="btn btn-secondary btn-sm waves-effect waves-light"
                                onClick={() => {
                                    getUserSale(record.Username)

                                }}>
                                <i className="fas fa-file-alt font-size-16 align-middle mr-2"></i> فروش ها
                            </button>
                        )}
                        {marketerSystem && userInfoResources && userInfoResources?.includes("BusinessAdmin") && (
                            <button type="dashed" className="btn btn-success btn-sm waves-effect waves-light"
                                onClick={() => {
                                    setAFee(record.Id)
                                }}>
                                <i className="bx bx-slider font-size-16 align-middle mr-2"></i> تنظیم کارمزد
                            </button>
                        )}
                        <button type="dashed" className="btn btn-info btn-sm waves-effect waves-light"
                            onClick={() => {
                                setSelectedEndorsementUserId(record.Id);
                                general.ToggleUserEndorsementReportModal();
                            }}>
                            <i className="fas fa-file-contract font-size-16 align-middle mr-2"></i> الحاقیه‌ها
                        </button>
                        {hasBimehContent && hasMobileChangePermission && isNormalCustomer && (
                            <button type="button" className="btn btn-warning btn-sm waves-effect waves-light"
                                onClick={() => {
                                    setSelectedMobileUser(record);
                                    setSelectedMobileUserName(record.Username);
                                    general.ToggleChangeMobileModal();
                                }}>
                                <i className="fas fa-mobile-alt font-size-16 align-middle mr-2"></i> تغییر موبایل
                            </button>
                        )}
                    </Space>
                )
            }
        },
    ];

    return (
        <Card>
            <SearchForm />
            <div style={{ float: "left" }}>
                <div className="users-buttons mt-3 mb-1" >
                    <button type="primary" className="btn btn-primary waves-effect waves-light mr-2" htmltype="submit"
                        onClick={() => {
                            general.ToggleUserAddModal()
                            if (!roleList?.length) {
                                getBusinessRole()
                            }
                        }}>
                        <i className="fas fa-user-plus font-size-14 align-middle mr-2"></i>افزودن کاربر
                    </button>

                    <button type="primary" className="btn btn-success waves-effect waves-light float-left"
                        onClick={() => {
                            general.ToggleUserUploadExcel()

                        }}>
                        بارگزاری لیست  <i className="far fa-file-excel font-size-14 align-middle mr-2"></i>
                    </button>

                </div>

            </div>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                bordered
                columns={columns}
                loading={initLoading}
                rowKey="Username"
                dataSource={search === false ? [...usersData] : [...usersList]}
                onChange={handleChange}
                scroll={{ x: 'max-content' }}
                pagination={false}
            />
            <Pagination
                onChange={pageChange}
                total={TotalUsers}
                pageSize={pageSize}
                showSizeChanger={false}
                defaultCurrent={pageNumber}
                current={pageNumber}
            />

            <EditUser pageNumber={pageNumber} pageSize={pageSize} member={member} sortDirection={sortDirection} />
            <AddUser />
            <UploadExcel />
            {userInfoResources && userInfoResources?.includes("BusinessAdmin") && <UserSales userName={selectedUserName} />}
            {marketerSystem && <UserWageSetting userId={selectedUserId} />}
            <UserBought userId={boughtUserId} />
            <UserEndorsementReport userId={selectedEndorsementUserId} />
            <ChangeMobileModal user={selectedMobileUser} userName={selectedMobileUserName} onSuccess={() => getusers()} />
        </Card >
    );
}

